// extracted by mini-css-extract-plugin
export var calculator = "RoiCalculator-module--calculator--ba67e";
export var calculatorLeft = "RoiCalculator-module--calculator-left--0786f";
export var container = "RoiCalculator-module--container--f8cc7";
export var conversionFunnel = "RoiCalculator-module--conversion-funnel--d876e";
export var digitalExperience = "RoiCalculator-module--digital-experience--41f90";
export var emerald = "RoiCalculator-module--emerald--c22c8";
export var eyebrow = "RoiCalculator-module--eyebrow--9c680";
export var pinkDeep = "RoiCalculator-module--pink-deep--d3a6b";
export var section = "RoiCalculator-module--section--ed0b0";
export var visualization = "RoiCalculator-module--visualization--eefd0";